import { round, getSymbolFromCurrency } from './../../utilities/index';
import { prop } from '../../utilities';

function getRequestDetailInfo(request) {
  const vatRate = prop(request, 'vat_rate', 20);
  const orderId = prop(request, 'order_id', '');
  const vs = prop(request, 'vs', '-') || '-';
  const yourNr = prop(request, 'demand_number', '-') || '-';
  let orderStatusReadable = prop(request, 'order_status_readable', '');
  const items = prop(request, 'items', '');
  const totalPrice = prop(request, 'order_tprice', 0);

  const totalPriceWithoutVat = prop(request, 'order_tprice_without_vat', 0);
  const currency = getSymbolFromCurrency(
    prop(request, 'order_tpricecurrency', 'EUR'),
  );
  const vat = totalPrice - totalPriceWithoutVat;
  const deliveryName = prop(request, 'delivery.delivery_typename');
  const paymentName = prop(request, 'payment.payment_typename');
  const deliveryPrice = prop(request, 'delivery.delivery_price');

  const paymentPrice = prop(request, 'payment.payment_price');
  const ordernr = prop(request, 'order_nr', '');
  const note = prop(request, 'order_note');
  const deliveryPriceWithoutVat = deliveryPrice
    ? deliveryPrice / (1 + vatRate / 100)
    : 0;
  const paymentPriceWithoutVat = paymentPrice
    ? paymentPrice / (1 + vatRate / 100)
    : 0;

  const orderStatus = prop(request, 'order_status', '');
  orderStatusReadable = getDemandStatusReadable(request);

  return {
    ordernr,
    orderId,
    orderStatus,
    vs,
    orderStatusReadable,
    items,
    yourNr,
    totalPrice: totalPrice ? round(totalPrice, 2) : 0,
    totalPriceWithoutVat: totalPriceWithoutVat
      ? round(totalPriceWithoutVat, 2)
      : 0,
    vat: vat ? round(vat, 2) : 0,
    currency,
    deliveryPrice,
    paymentPrice,
    deliveryPriceWithoutVat,
    paymentPriceWithoutVat,
    note,
    deliveryName,
    paymentName,
  };
}

function getDemandStatusReadable(request) {
  // let orderStatusReadable = '';
  // const orderStatus = prop(request, 'order_status', '');
  // if (orderStatus === 'NEW') {
  //   orderStatusReadable = 'Prijaté';
  // } else if (orderStatus === 'INPROGRESS') {
  //   orderStatusReadable = 'Pripravené na objednanie';
  // } else if (orderStatus === 'SHIPPED') {
  //   orderStatusReadable = 'Objednávka';
  // }
  // return orderStatusReadable;
  return prop(request, 'order_status_readable', '');
}

export { getRequestDetailInfo };
